// extracted by mini-css-extract-plugin
export default {"root":"SimpleTruncate_root__pgiAv","overflowEllipsis":"SimpleTruncate_overflowEllipsis__Qm1Cq","isMultiLineTruncate":"SimpleTruncate_isMultiLineTruncate__rprUr"};